import { Provider } from 'react-redux'
import { store } from './store/store'
import { RouterProvider } from 'react-router-dom'
import { routes } from './routes'
import { StepsContextProvider } from './contexts/steps'
import { UploadContextProvider } from './contexts/upload'
import { Toaster } from 'sonner'

function App() {
  return (
    <Provider store={store}>
      <StepsContextProvider>
        <UploadContextProvider>
          <Toaster richColors duration={5000} position="bottom-right" />

          <RouterProvider router={routes} />
        </UploadContextProvider>
      </StepsContextProvider>
    </Provider>
  )
}

export default App
